import { Box, Button, Grid, TextField, useTheme } from "@mui/material";
//import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
//import Header from "../../components/Header";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
//import InputBase from "@mui/material/InputBase";
//import SearchIcon from "@mui/icons-material/Search";
import SearchBar from "../../components/searchbar";
//import { mockSearchData } from "../../data/mockData";
import { Select } from "@mui/material";
import { useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import React, { useEffect } from "react";
import { getAllPatients } from "../../services/patientService";
import { registerPatient } from "../../services/patientService";
import { updatePatient, syncPatientTypeForWorkflow } from "../../services/patientService";

import { getAllDoctors } from "../../services/doctorService";
import { scheduleRemindersForAppointment } from "../../services/appointmentReminderService";

import CustomDatePicker from "../../components/DateTimePicker";
import CustomTimePicker from "../../components/TimePicker";
import MenuItem from "@mui/material/MenuItem";
// import { LocalizationProvider, DatePicker, TimePicker } from '@mui/lab';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import appointmentService from "../../services/appointmentService";
import SearchDropDown from "../../components/SeacrhDropDown";

const Form = () => {
  const colorMode = useContext(ColorModeContext);
  const [patientId, setPatientId] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [name, setName] = useState("");
  const [aadhar, setAadhar] = useState("");
  const [ailment, setAilment] = useState("");
  const [complaints, setComplaints] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [appointmentDate, setAppointmentDate] = useState(new Date());
  const [appointmentTime, setAppointmentTime] = useState(new Date());
  const [openModal, setOpenModal] = useState(false);
  const [registeredPatient, setRegisteredPatient] = useState(null);
  const [originalAppointmentDate, setOriginalAppointmentDate] = useState(
    new Date()
  );
  const [originalAppointmentTime, setOriginalAppointmentTime] = useState(
    new Date()
  );

  useEffect(() => {
    fetchDoctors();
    handleSearch();
  }, []);

  // const handleFormSubmit = (values) => {
  //   console.log(values);
  // };
  const [age, setAge] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const fetchDoctors = async () => {
    try {
      const data = await getAllDoctors();
      setDoctors(data);
    } catch (error) {
      console.error("Failed to fetch doctors:", error);
    }
  };

  const [patients, setPatients] = useState([]);

  const handleSearch = async () => {
    try {
      const data = await getAllPatients();
      setPatients(data);
    } catch (error) {
      console.error("Failed to search patients:", error);
    }
  };

  const formatDateTimeWithoutOffset = (date) => {
    const pad = (number) => (number < 10 ? "0" : "") + number;
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes())
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const appointmentDateTime = new Date(appointmentDate);
    // appointmentDateTime.setHours(appointmentTime.getHours());
    // appointmentDateTime.setMinutes(appointmentTime.getMinutes());
    const newPatient = {
      id: patientId,
      name,
      ailment,
      doctor: { id: selectedDoctor },
      aadhar,
      complaints,
      mobile,
      email,
      patientType: "OUT",
      appointmentDateTime: formatDateTimeWithoutOffset(appointmentDateTime), // Remove the offset
    };

    try {
      if (patientId) {
        await updatePatient(patientId, newPatient);
        alert("Patient updated successfully");
        // Check if appointment date and time have changed
        if (
          appointmentDateTime.getTime() !== originalAppointmentDate.getTime()
        ) {
          newPatient.appointmentDateTime =
            formatDateTimeWithoutOffset(appointmentDateTime);
        } else {
          newPatient.appointmentDateTime = null;
        }
        if (newPatient.appointmentDateTime) {
          const createdAppointment = await appointmentService.createAppointment({
            patientId: patientId,
            doctorId: selectedDoctor,
            appointmentDateTime: newPatient.appointmentDateTime,
          });
          await syncPatientTypeForWorkflow(patientId, "OUT", { force: true });
          scheduleRemindersForAppointment(
            {
              ...createdAppointment,
              appointmentDateTime: newPatient.appointmentDateTime,
              patientId,
              doctorId: selectedDoctor,
            },
            {
              patient: { id: patientId, mobile, name },
            }
          ).catch((error) => {
            console.error("Failed to schedule appointment reminders:", error);
          });
        }
      } else {
        const registeredPatient = await registerPatient(newPatient);
        setRegisteredPatient(registeredPatient);
        setOpenModal(true);

        if (registeredPatient?.portalCredentials) {
          alert(
            `Patient registered successfully. Temporary password: ${registeredPatient.portalCredentials.password}`
          );
        } else {
          alert("Patient registered successfully");
        }

        const createdAppointment = await appointmentService.createAppointment({
          patientId: registeredPatient.id,
          doctorId: selectedDoctor,
          appointmentDateTime: formatDateTimeWithoutOffset(appointmentDateTime),
        });
        await syncPatientTypeForWorkflow(registeredPatient.id, "OUT", { force: true });
        scheduleRemindersForAppointment(
          {
            ...createdAppointment,
            appointmentDateTime: formatDateTimeWithoutOffset(appointmentDateTime),
            patientId: registeredPatient.id,
            doctorId: selectedDoctor,
          },
          {
            patient: registeredPatient,
          }
        ).catch((error) => {
          console.error("Failed to schedule appointment reminders:", error);
        });
      }
      handleSearch();
      //alert('Patient registered successfully');
      // Clear form fields
      //window.location.reload(); // Reload the page after successful registration
      setName("");
      setAge("");
      setAilment("");
      setSelectedDoctor("");
      setAadhar("");
      setComplaints("");
      setMobile("");
      setEmail("");
      setAppointmentDate("");
      setAppointmentTime("");
    } catch (error) {
      console.error("Error registering patient:", error);
      alert("Failed to register patient");
    }
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handlePatientSelect = (patient) => {
    setPatientId(patient?.id || "");
    setName(patient?.name || "");
    setEmail(patient?.email || "");
    setComplaints(patient?.complaints || "");
    // setSelectedDoctor(patient?.doctor?.id||"");
    setAadhar(patient?.aadhar || "");
    setMobile(patient?.mobile || "");

    const appDateTime = new Date(patient?.AppointmentDateTime || new Date());
    setAppointmentDate(appDateTime || "");
    setAppointmentTime(appDateTime || "");
    // Store original appointment date and time
    setOriginalAppointmentDate(appDateTime || "");
    setOriginalAppointmentTime(appDateTime || "");
  };

  return (
    <Box>
      <h2>{patientId ? "Update Patient" : "Register Patient"}</h2>
      <Grid container mb={4}>
        <Grid md={4} item>
          <SearchDropDown
            placeholder="Search existing patients and assign a doctor"
            data={patients}
            onPatientSelect={handlePatientSelect}
          />
        </Grid>
      </Grid>

      {/* <SearchBar
        placeholder="Search Existing Patients"
        data={patients}
        onPatientSelect={handlePatientSelect}
      /> */}

      <form onSubmit={handleFormSubmit}>
        <Box
          display="grid"
          gap="30px"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="First Name"
            //onBlur={handleBlur}
            onChange={(e) => setName(e.target.value)}
            value={name}
            name="name"
            //error={!!touched.name && !!errors.name}
            //helperText={touched.name && errors.name}
            sx={{ gridColumn: "span 2" }}
            required
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Aadhar"
            //onBlur={handleBlur}
            onChange={(e) => setAadhar(e.target.value)}
            value={aadhar}
            name="aadhar"
            //error={!!touched.aadhar && !!errors.aadhar}
            //helperText={touched.aadhar && errors.aadhar}
            sx={{ gridColumn: "span 2" }}
            required
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Email"
            //onBlur={handleBlur}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            name="email"
            //error={!!touched.email && !!errors.email}
            //helperText={touched.email && errors.email}
            sx={{ gridColumn: "span 4" }}
            required
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Contact Number"
            //onBlur={handleBlur}
            onChange={(e) => setMobile(e.target.value)}
            value={mobile}
            name="contact"
            //error={!!touched.mobile && !!errors.mobile}
            //helperText={touched.mobile && errors.mobile}
            sx={{ gridColumn: "span 4" }}
          />
          <CustomDatePicker
            selectedDate={appointmentDate}
            onDateChange={(newDate) => setAppointmentDate(newDate)}
            //renderInput={(params) => <TextField {...params} />}
            required
          />
          <CustomTimePicker
            selectedTime={appointmentTime}
            onTimeChange={(newTime) => setAppointmentTime(newTime)}
            //renderInput={(params) => <TextField {...params} />}
            required
          />
          {/* <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Address 2"
                //onBlur={handleBlur}
                onChange={handleChange}
                value={values.address2}
                name="address2"
                //error={!!touched.address2 && !!errors.address2}
                //helperText={touched.address2 && errors.address2}
                sx={{ gridColumn: "span 2" }}
              /> */}
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Complains"
            //onBlur={handleBlur}
            onChange={(e) => setComplaints(e.target.value)}
            value={complaints}
            name="Complains"
            //error={!!touched.complaints && !!errors.complaints}
            //helperText={touched.complaints && errors.complaints}
            sx={{ gridColumn: "span 2" }}
          />
          <FormControl variant="filled" sx={{ minWidth: 465 }}>
            <InputLabel id="demo">Assign a Doctor</InputLabel>
            <Select
              className="selectForm"
              variant="filled"
              labelId="demo"
              id="demo"
              value={selectedDoctor}
              onChange={(e) => setSelectedDoctor(e.target.value)}
            >
              {doctors.map((doctor) => (
                <MenuItem key={doctor.id} value={doctor.id}>
                  {doctor.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box display="flex" justifyContent="end" mt="20px">
          <Button type="submit" color="secondary" variant="contained">
            {patientId ? "Update" : "Register"}
          </Button>
        </Box>
      </form>
      {/* {registeredPatient && (
        <InvoiceModal
          open={openModal}
          handleClose={handleClose}
          patient={registeredPatient}
        />
      )} */}
    </Box>
  );
};

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  email: yup.string().email("invalid email").required("required"),
  contact: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  address1: yup.string().required("required"),
  address2: yup.string().required("required"),
});
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  contact: "",
  address1: "",
  address2: "",
};

export default Form;
